import { RippleModule } from 'primeng/ripple';

import { Component, OnInit, ChangeDetectionStrategy, output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { BehaviorSubject } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';


@Component({
  selector: 'new-prospect',
  templateUrl: './new-prospect.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ButtonModule,
    RippleModule,
    TranslateModule
]
})
export class NewProspectComponent implements OnInit {
  readonly onAction = output<{ action: string }>();
  selectedClient: any = new Map()
  clients: any = new BehaviorSubject([])
  constructor() { }

  ngOnInit(): void {
  }

  get getSelectedClientData(): Array<any> {
    return [...this.selectedClient.values()];
  }

  OpenPopup() {
    this.onAction.emit({action:"CreateProspect"});
  }
}
